/* eslint-disable react/no-array-index-key */
import { RadioGroup, Radio, Checkbox } from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

const Join = ({
    updatedConfigData, subOperator, onChecked, onHandleChange, joinColumns,
}) => (
    <div>
        <div className="true-comply-datarecon__join-header">
            <p>Select join category : </p>
            <div className="true-comply-datarecon__radio-section">
                <RadioGroup
                    name="radioname"
                    value={subOperator}
                    onChange={onChecked}
                >
                    <Radio
                        value="outer"
                    >
                        Outer Join
                    </Radio>
                    <Radio
                        value="inner"
                    >
                        Inner Join
                    </Radio>
                    <Radio
                        value="left"
                    >
                        Left Join
                    </Radio>
                    <Radio
                        value="right"
                    >
                        Right Join
                    </Radio>
                </RadioGroup>
            </div>
        </div>
        <div>{'\n'}</div>
        <div className="true-comply-datarecon__join-body">
            <Row>
                <Col>
                    <p className="true-comply-datarecon__reconcliationtype-join__title">COLUMN LIST</p>
                    <Row>
                        { updatedConfigData && updatedConfigData.map(c => (
                            <Col key={c.id}>
                                <p>{c.fileDisplayName}</p>
                                <ul className="true-comply-datarecon__reconcliationtype-join__list-checkbox">
                                    {
                                        c.selectedColumns.map(
                                            (data, index) => (
                                                <li key={`${data.column}_${index}`}>
                                                    <Checkbox
                                                        checked={data.isJoin}
                                                        onChange={onHandleChange}
                                                        id={c.id}
                                                        name={data.column}
                                                        value={data.column}
                                                    >
                                                        {data.column}
                                                    </Checkbox>
                                                </li>
                                            ),
                                        )
                                    }
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </Col>
                <Col>
                    <p className="true-comply-datarecon__reconcliationtype-join__title">DATA JOINING</p>
                    <Row>
                        { joinColumns && joinColumns.map(c => (
                            <Col key={c.id}>
                                <p>{c.fileDisplayName}</p>
                                <ul className="true-comply-datarecon__reconcliationtype-join__list">
                                    {
                                        c.selectedColumns.map((data, index) => <li key={`${data.column}_${index}`}>{data.column}</li>)
                                    }
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    </div>
);

export default Join;
